import { Fragment } from "react";
import { MessageSquare, Settings } from "react-feather";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { Badges, Btn, H5, LI, UL } from "../../../../AbstractElements";
import { AskQuestion, Navigation } from "../../../../Constants/Constants";
import { NavigationData } from "../../../../Data/Miscellaneous/FAQ";

const NavigationCard = () => {
  return (
    <Col lg="12">
      <Card className="card-mb-faq">
        <CardHeader className="faq-header pb-0">
          <H5>{Navigation}</H5>
          <Settings />
        </CardHeader>
        <CardBody className="faq-body">
          <div className="navigation-btn">
            <Btn color="primary" className="d-flex">
              <MessageSquare className="m-r-10" /> {AskQuestion}
            </Btn>
          </div>
          <div className="navigation-option">
            {NavigationData.map((data) => (
              <Fragment key={data.id}>
                <UL className="simple-list">
                  {data.child.map((item) => (
                    <LI key={item.id}>
                      <Link to={item.link}>
                        {item.icon} {item.text}
                      </Link>
                      {item.badge && (
                        <Badges color="primary" className="pull-right" pill>
                          {item.badge}
                        </Badges>
                      )}
                    </LI>
                  ))}
                </UL>
                {data.id !== NavigationData.length && <hr />}
              </Fragment>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default NavigationCard;
